// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CorrectionsRouteImport } from './routes/corrections'
import { Route as EditorialStandardsRouteImport } from './routes/editorial-standards'
import { Route as EmbedsRouteImport } from './routes/embeds'
import { Route as EthicsRouteImport } from './routes/ethics'
import { Route as LocalSearchIndexRouteImport } from './routes/local-search-index'
import { Route as NewsroomRouteImport } from './routes/newsroom'
import { Route as OwnershipAndFundingRouteImport } from './routes/ownership-and-funding'
import { Route as PressRouteImport } from './routes/press'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WriteForUsRouteImport } from './routes/write-for-us'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminArticlesRouteImport } from './routes/admin.articles'
import { Route as AdminAuthorsRouteImport } from './routes/admin.authors'
import { Route as AdminBackfillRouteImport } from './routes/admin.backfill'
import { Route as AdminGenerateRouteImport } from './routes/admin.generate'
import { Route as AdminIdeasRouteImport } from './routes/admin.ideas'
import { Route as AdminInboxRouteImport } from './routes/admin.inbox'
import { Route as AdminLaunchKitsRouteImport } from './routes/admin.launch-kits'
import { Route as AdminNewRouteImport } from './routes/admin.new'
import { Route as AdminScheduleRouteImport } from './routes/admin.schedule'
import { Route as AdminSubscribersRouteImport } from './routes/admin.subscribers'
import { Route as AdminTopicsRouteImport } from './routes/admin.topics'
import { Route as ApiV1RouteImport } from './routes/api.v1'
import { Route as ArticleSlugRouteImport } from './routes/article.$slug'
import { Route as CategorySlugRouteImport } from './routes/category.$slug'
import { Route as ChangelogIndexRouteImport } from './routes/changelog.index'
import { Route as ChangelogSlugRouteImport } from './routes/changelog.$slug'
import { Route as EmbedHealthCheckRouteImport } from './routes/embed.health-check'
import { Route as EmbedLastUpdateRouteImport } from './routes/embed.last-update'
import { Route as EmbedVolatilityRouteImport } from './routes/embed.volatility'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as GuideIndexRouteImport } from './routes/guide.index'
import { Route as GuideSlugRouteImport } from './routes/guide.$slug'
import { Route as SponsorsGbplyRouteImport } from './routes/sponsors.gbply'
import { Route as StateOfLocalSearchIndexRouteImport } from './routes/state-of-local-search.index'
import { Route as StateOfLocalSearchYearRouteImport } from './routes/state-of-local-search.$year'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as UpdatesIndexRouteImport } from './routes/updates.index'
import { Route as UpdatesSlugRouteImport } from './routes/updates.$slug'
import { Route as AdminEditIdRouteImport } from './routes/admin.edit.$id'
import { Route as ToolsGbpAttributesIndexRouteImport } from './routes/tools.gbp-attributes.index'
import { Route as ToolsGbpAttributesSlugRouteImport } from './routes/tools.gbp-attributes.$slug'
import { Route as ToolsGbpCategoriesIndexRouteImport } from './routes/tools.gbp-categories.index'
import { Route as ToolsGbpCategoriesSlugRouteImport } from './routes/tools.gbp-categories.$slug'
import { Route as ToolsJustificationsIndexRouteImport } from './routes/tools.justifications.index'
import { Route as ToolsJustificationsSlugRouteImport } from './routes/tools.justifications.$slug'
import { Route as ToolsLocalSchemaIndexRouteImport } from './routes/tools.local-schema.index'
import { Route as ToolsSuspensionsIndexRouteImport } from './routes/tools.suspensions.index'
import { Route as ToolsSuspensionsSlugRouteImport } from './routes/tools.suspensions.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CorrectionsRoute = CorrectionsRouteImport.update({
            id: '/corrections',path: '/corrections',getParentRoute: () => rootRouteImport
          })
const EditorialStandardsRoute = EditorialStandardsRouteImport.update({
            id: '/editorial-standards',path: '/editorial-standards',getParentRoute: () => rootRouteImport
          })
const EmbedsRoute = EmbedsRouteImport.update({
            id: '/embeds',path: '/embeds',getParentRoute: () => rootRouteImport
          })
const EthicsRoute = EthicsRouteImport.update({
            id: '/ethics',path: '/ethics',getParentRoute: () => rootRouteImport
          })
const LocalSearchIndexRoute = LocalSearchIndexRouteImport.update({
            id: '/local-search-index',path: '/local-search-index',getParentRoute: () => rootRouteImport
          })
const NewsroomRoute = NewsroomRouteImport.update({
            id: '/newsroom',path: '/newsroom',getParentRoute: () => rootRouteImport
          })
const OwnershipAndFundingRoute = OwnershipAndFundingRouteImport.update({
            id: '/ownership-and-funding',path: '/ownership-and-funding',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WriteForUsRoute = WriteForUsRouteImport.update({
            id: '/write-for-us',path: '/write-for-us',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminArticlesRoute = AdminArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => AdminRoute
          })
const AdminAuthorsRoute = AdminAuthorsRouteImport.update({
            id: '/authors',path: '/authors',getParentRoute: () => AdminRoute
          })
const AdminBackfillRoute = AdminBackfillRouteImport.update({
            id: '/backfill',path: '/backfill',getParentRoute: () => AdminRoute
          })
const AdminGenerateRoute = AdminGenerateRouteImport.update({
            id: '/generate',path: '/generate',getParentRoute: () => AdminRoute
          })
const AdminIdeasRoute = AdminIdeasRouteImport.update({
            id: '/ideas',path: '/ideas',getParentRoute: () => AdminRoute
          })
const AdminInboxRoute = AdminInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AdminRoute
          })
const AdminLaunchKitsRoute = AdminLaunchKitsRouteImport.update({
            id: '/launch-kits',path: '/launch-kits',getParentRoute: () => AdminRoute
          })
const AdminNewRoute = AdminNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminRoute
          })
const AdminScheduleRoute = AdminScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AdminRoute
          })
const AdminSubscribersRoute = AdminSubscribersRouteImport.update({
            id: '/subscribers',path: '/subscribers',getParentRoute: () => AdminRoute
          })
const AdminTopicsRoute = AdminTopicsRouteImport.update({
            id: '/topics',path: '/topics',getParentRoute: () => AdminRoute
          })
const ApiV1Route = ApiV1RouteImport.update({
            id: '/api/v1',path: '/api/v1',getParentRoute: () => rootRouteImport
          })
const ArticleSlugRoute = ArticleSlugRouteImport.update({
            id: '/article/$slug',path: '/article/$slug',getParentRoute: () => rootRouteImport
          })
const CategorySlugRoute = CategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => rootRouteImport
          })
const ChangelogIndexRoute = ChangelogIndexRouteImport.update({
            id: '/changelog/',path: '/changelog/',getParentRoute: () => rootRouteImport
          })
const ChangelogSlugRoute = ChangelogSlugRouteImport.update({
            id: '/changelog/$slug',path: '/changelog/$slug',getParentRoute: () => rootRouteImport
          })
const EmbedHealthCheckRoute = EmbedHealthCheckRouteImport.update({
            id: '/embed/health-check',path: '/embed/health-check',getParentRoute: () => rootRouteImport
          })
const EmbedLastUpdateRoute = EmbedLastUpdateRouteImport.update({
            id: '/embed/last-update',path: '/embed/last-update',getParentRoute: () => rootRouteImport
          })
const EmbedVolatilityRoute = EmbedVolatilityRouteImport.update({
            id: '/embed/volatility',path: '/embed/volatility',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const GuideIndexRoute = GuideIndexRouteImport.update({
            id: '/guide/',path: '/guide/',getParentRoute: () => rootRouteImport
          })
const GuideSlugRoute = GuideSlugRouteImport.update({
            id: '/guide/$slug',path: '/guide/$slug',getParentRoute: () => rootRouteImport
          })
const SponsorsGbplyRoute = SponsorsGbplyRouteImport.update({
            id: '/sponsors/gbply',path: '/sponsors/gbply',getParentRoute: () => rootRouteImport
          })
const StateOfLocalSearchIndexRoute = StateOfLocalSearchIndexRouteImport.update({
            id: '/state-of-local-search/',path: '/state-of-local-search/',getParentRoute: () => rootRouteImport
          })
const StateOfLocalSearchYearRoute = StateOfLocalSearchYearRouteImport.update({
            id: '/state-of-local-search/$year',path: '/state-of-local-search/$year',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const UpdatesIndexRoute = UpdatesIndexRouteImport.update({
            id: '/updates/',path: '/updates/',getParentRoute: () => rootRouteImport
          })
const UpdatesSlugRoute = UpdatesSlugRouteImport.update({
            id: '/updates/$slug',path: '/updates/$slug',getParentRoute: () => rootRouteImport
          })
const AdminEditIdRoute = AdminEditIdRouteImport.update({
            id: '/edit/$id',path: '/edit/$id',getParentRoute: () => AdminRoute
          })
const ToolsGbpAttributesIndexRoute = ToolsGbpAttributesIndexRouteImport.update({
            id: '/tools/gbp-attributes/',path: '/tools/gbp-attributes/',getParentRoute: () => rootRouteImport
          })
const ToolsGbpAttributesSlugRoute = ToolsGbpAttributesSlugRouteImport.update({
            id: '/tools/gbp-attributes/$slug',path: '/tools/gbp-attributes/$slug',getParentRoute: () => rootRouteImport
          })
const ToolsGbpCategoriesIndexRoute = ToolsGbpCategoriesIndexRouteImport.update({
            id: '/tools/gbp-categories/',path: '/tools/gbp-categories/',getParentRoute: () => rootRouteImport
          })
const ToolsGbpCategoriesSlugRoute = ToolsGbpCategoriesSlugRouteImport.update({
            id: '/tools/gbp-categories/$slug',path: '/tools/gbp-categories/$slug',getParentRoute: () => rootRouteImport
          })
const ToolsJustificationsIndexRoute = ToolsJustificationsIndexRouteImport.update({
            id: '/tools/justifications/',path: '/tools/justifications/',getParentRoute: () => rootRouteImport
          })
const ToolsJustificationsSlugRoute = ToolsJustificationsSlugRouteImport.update({
            id: '/tools/justifications/$slug',path: '/tools/justifications/$slug',getParentRoute: () => rootRouteImport
          })
const ToolsLocalSchemaIndexRoute = ToolsLocalSchemaIndexRouteImport.update({
            id: '/tools/local-schema/',path: '/tools/local-schema/',getParentRoute: () => rootRouteImport
          })
const ToolsSuspensionsIndexRoute = ToolsSuspensionsIndexRouteImport.update({
            id: '/tools/suspensions/',path: '/tools/suspensions/',getParentRoute: () => rootRouteImport
          })
const ToolsSuspensionsSlugRoute = ToolsSuspensionsSlugRouteImport.update({
            id: '/tools/suspensions/$slug',path: '/tools/suspensions/$slug',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminArticlesRoute: AdminArticlesRoute,AdminAuthorsRoute: AdminAuthorsRoute,AdminBackfillRoute: AdminBackfillRoute,AdminGenerateRoute: AdminGenerateRoute,AdminIdeasRoute: AdminIdeasRoute,AdminInboxRoute: AdminInboxRoute,AdminLaunchKitsRoute: AdminLaunchKitsRoute,AdminNewRoute: AdminNewRoute,AdminScheduleRoute: AdminScheduleRoute,AdminSubscribersRoute: AdminSubscribersRoute,AdminTopicsRoute: AdminTopicsRoute,AdminIndexRoute: AdminIndexRoute,AdminEditIdRoute: AdminEditIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,CorrectionsRoute: CorrectionsRoute,EditorialStandardsRoute: EditorialStandardsRoute,EmbedsRoute: EmbedsRoute,EthicsRoute: EthicsRoute,LocalSearchIndexRoute: LocalSearchIndexRoute,NewsroomRoute: NewsroomRoute,OwnershipAndFundingRoute: OwnershipAndFundingRoute,PressRoute: PressRoute,UnsubscribeRoute: UnsubscribeRoute,WriteForUsRoute: WriteForUsRoute,ApiV1Route: ApiV1Route,ArticleSlugRoute: ArticleSlugRoute,CategorySlugRoute: CategorySlugRoute,ChangelogSlugRoute: ChangelogSlugRoute,EmbedHealthCheckRoute: EmbedHealthCheckRoute,EmbedLastUpdateRoute: EmbedLastUpdateRoute,EmbedVolatilityRoute: EmbedVolatilityRoute,GlossarySlugRoute: GlossarySlugRoute,GuideSlugRoute: GuideSlugRoute,SponsorsGbplyRoute: SponsorsGbplyRoute,StateOfLocalSearchYearRoute: StateOfLocalSearchYearRoute,UpdatesSlugRoute: UpdatesSlugRoute,ChangelogIndexRoute: ChangelogIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,GuideIndexRoute: GuideIndexRoute,StateOfLocalSearchIndexRoute: StateOfLocalSearchIndexRoute,ToolsIndexRoute: ToolsIndexRoute,UpdatesIndexRoute: UpdatesIndexRoute,ToolsGbpAttributesSlugRoute: ToolsGbpAttributesSlugRoute,ToolsGbpCategoriesSlugRoute: ToolsGbpCategoriesSlugRoute,ToolsJustificationsSlugRoute: ToolsJustificationsSlugRoute,ToolsSuspensionsSlugRoute: ToolsSuspensionsSlugRoute,ToolsGbpAttributesIndexRoute: ToolsGbpAttributesIndexRoute,ToolsGbpCategoriesIndexRoute: ToolsGbpCategoriesIndexRoute,ToolsJustificationsIndexRoute: ToolsJustificationsIndexRoute,ToolsLocalSchemaIndexRoute: ToolsLocalSchemaIndexRoute,ToolsSuspensionsIndexRoute: ToolsSuspensionsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)